import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllAppointments = (query) => {
  return Api(
    `${endPoints.getAllAppointments}?workerStatus=${
      query.workerStatus || "All"
    }&status=${query.status || "All"}&companyId=${
      query.company || "All"
    }&workerId=${query.worker || "All"}`,
    null,
    requestType.GET
  );
};

const getAppointmentDetail = (id) => {
  return Api(`${endPoints.getAppointmentDetail}/${id}`, null, requestType.GET);
};

const assignedAppoitment = (id, payload) => {
  return Api(`${endPoints.assignedAppoitment}/${id}`, payload, requestType.PUT);
};

export { getAllAppointments, getAppointmentDetail, assignedAppoitment };
